// Test IDs for the landing page (Dickies-Campus Bildungszentrum)
export const NAV = {
  logo: 'nav-logo-link',
  linkKurse: 'nav-link-kurse',
  linkPflegekraft: 'nav-link-pflegekraft',
  linkEinrichtung: 'nav-link-einrichtung',
  linkFaq: 'nav-link-faq',
  linkContact: 'nav-link-kontakt',
  ctaBeratung: 'nav-cta-beratung',
  mobileToggle: 'nav-mobile-toggle',
  mobileSheet: 'nav-mobile-sheet',
};

export const HERO = {
  primaryCta: 'hero-cta-beratung',
  secondaryCta: 'hero-cta-kurse',
  trustBadge: 'hero-trust-badge',
  phoneCta: 'hero-cta-phone',
};

export const AUDIENCE = {
  cardPflegekraft: 'audience-card-pflegekraft',
  cardEinrichtung: 'audience-card-einrichtung',
};

export const COURSES = {
  tabs: 'courses-tabs',
  tabEinstieg: 'courses-tab-einstieg',
  tabErfahren: 'courses-tab-erfahren',
  tabFuehrung: 'courses-tab-fuehrung',
  tabPflicht: 'courses-tab-pflicht',
  card: 'course-card',
  cardCta: 'course-card-cta',
};

export const PROCESS = {
  step: 'process-step',
};

export const TESTIMONIALS = {
  card: 'testimonial-card',
};

export const QUIZ = {
  start: 'quiz-start-button',
  option: 'quiz-option-button',
  restart: 'quiz-restart-button',
  result: 'quiz-result-card',
  resultCta: 'quiz-result-cta',
};

export const FAQ = {
  accordion: 'faq-accordion',
  item: 'faq-item',
};

export const LEAD = {
  form: 'lead-form',
  name: 'lead-form-name-input',
  email: 'lead-form-email-input',
  phone: 'lead-form-phone-input',
  audience: 'lead-form-audience-select',
  course: 'lead-form-course-select',
  message: 'lead-form-message-input',
  consent: 'lead-form-consent-checkbox',
  submit: 'lead-form-submit-button',
  phoneCta: 'lead-phone-cta',
  whatsappCta: 'lead-whatsapp-cta',
};

export const FOOTER = {
  impressum: 'footer-link-impressum',
  datenschutz: 'footer-link-datenschutz',
  kontakt: 'footer-link-kontakt',
};
